(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vainilla-collection-scroll"] && !Shopify.designMode) return;
  try {
    class VainillaCollectionScroll extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.grid = this.closest('.collection')?.querySelector('ul#product-grid');
      if (!this.grid || !window.fetch || !window.AbortController) return;
      this.ready = true;
      this.page = Number(this.dataset.page);
      this.nextURL = this.dataset.nextUrl;
      this.queryKey = this.getQueryKey();
      this.more = this.querySelector('[data-scroll-more]');
      this.pause = this.querySelector('[data-scroll-pause]');
      this.status = this.querySelector('[data-scroll-status]');
      this.fallback = this.querySelector('[data-scroll-pagination]');
      this.fallback.hidden = true;
      this.querySelector('[data-scroll-controls]').hidden = false;
      this.paused = !('IntersectionObserver' in window);
      this.more.onclick = () => this.loadMore(true);
      this.pause.onclick = () => {
        this.paused = !this.paused;
        this.refresh();
        this.observeEnd();
      };
      this.savePosition = () => {
        if (!this.isConnected || this.restoring || this.queryKey !== this.getQueryKey()) return;
        const cards = [...this.grid.children];
        const anchor = cards.find(card => card.getBoundingClientRect().bottom > 180);
        try {
          sessionStorage.setItem('vainilla-collection-return', JSON.stringify({
            query: this.queryKey, page: this.page, paused: this.paused, y: window.scrollY,
            product: anchor?.dataset.productId, top: anchor?.getBoundingClientRect().top, at: Date.now()
          }));
        } catch (_) {}
      };
      window.addEventListener('pagehide', this.savePosition);
      this.grid.addEventListener('click', this.savePosition);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting) && !this.paused && !this.restoring && !this.failed) this.loadMore();
        }, { rootMargin: '0px 0px 450px 0px' });
      }
      this.refresh();
      this.restorePosition().finally(() => this.observeEnd());
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
      window.removeEventListener('pagehide', this.savePosition);
      this.grid?.removeEventListener('click', this.savePosition);
      this.ready = false;
    }
    getQueryKey() {
      const url = new URL(window.location.href);
      url.searchParams.delete('preview_theme_id');
      url.searchParams.delete('section_id');
      url.searchParams.sort();
      return url.pathname + url.search;
    }
    refresh() {
      const shown = this.grid.children.length;
      const offset = Number(this.dataset.offset);
      const label = offset ? this.dataset.rangeLabel : this.dataset.countLabel;
      this.querySelector('[data-scroll-count]').textContent = label
        .replace('__shown__', shown).replace('__first__', offset + 1)
        .replace('__last__', offset + shown).replace('__total__', this.dataset.total);
      this.more.hidden = !this.nextURL;
      this.more.disabled = !!this.loading;
      this.pause.hidden = !this.nextURL || !this.observer;
      this.pause.textContent = this.paused ? this.dataset.resumeLabel : this.dataset.pauseLabel;
      this.pause.setAttribute('aria-pressed', String(this.paused));
      if (!this.nextURL) this.status.textContent = this.dataset.finishedLabel;
    }
    observeEnd() {
      this.observer?.disconnect();
      if (this.isConnected && this.nextURL && !this.paused && !this.failed && !this.restoring && this.queryKey === this.getQueryKey() && !this.closest('.collection').classList.contains('loading')) this.observer?.observe(this);
    }
    async loadMore(manual = false) {
      if (this.loading || !this.nextURL || !this.isConnected || this.queryKey !== this.getQueryKey() || this.closest('.collection').classList.contains('loading')) return false;
      this.loading = true;
      this.failed = false;
      this.observer?.disconnect();
      this.more.disabled = true;
      this.grid.setAttribute('aria-busy', 'true');
      this.status.textContent = this.restoring ? this.dataset.restoringLabel : this.dataset.loadingLabel;
      this.controller = new AbortController();
      const timeout = setTimeout(() => this.controller.abort(), 15000);
      let success = false;
      try {
        const url = new URL(this.nextURL, window.location.href);
        if (url.origin !== window.location.origin || url.pathname !== window.location.pathname) throw new Error('invalid_page');
        url.searchParams.set('section_id', this.dataset.sectionId);
        const response = await fetch(url, { credentials: 'same-origin', signal: this.controller.signal });
        if (!response.ok) throw new Error('unavailable_page');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const grid = doc.querySelector('ul#product-grid');
        const pagination = doc.querySelector('vainilla-collection-scroll');
        if (!grid || grid.dataset.id !== this.dataset.sectionId || !pagination || Number(pagination.dataset.page) !== this.page + 1) throw new Error('invalid_products');
        if (!this.isConnected || this.queryKey !== this.getQueryKey() || this.closest('.collection').classList.contains('loading')) return false;
        const existing = new Set([...this.grid.children].map(card => card.dataset.productId));
        const cards = [...grid.children].filter(card => {
          const id = card.dataset.productId;
          if (!id || existing.has(id)) return false;
          existing.add(id);
          return true;
        }).map(card => document.importNode(card, true));
        if (!cards.length) throw new Error('empty_page');
        cards.forEach(card => {
          card.classList.add('scroll-trigger--cancel');
          card.querySelectorAll('.scroll-trigger').forEach(el => el.classList.add('scroll-trigger--cancel'));
        });
        this.grid.append(...cards);
        this.page = Number(pagination.dataset.page);
        this.nextURL = pagination.dataset.nextUrl;
        this.dataset.page = String(this.page);
        this.dataset.nextUrl = this.nextURL;
        this.fallback.innerHTML = pagination.querySelector('[data-scroll-pagination]').innerHTML;
        this.fallback.hidden = true;
        this.status.textContent = '';
        try { window.bucksCC?.reConvert?.(); } catch (_) {}
        if (manual) cards[0].querySelector('a')?.focus({ preventScroll: true });
        success = true;
      } catch (_) {
        if (this.isConnected) {
          this.failed = true;
          this.status.textContent = this.dataset.errorLabel;
          this.fallback.hidden = false;
        }
      } finally {
        clearTimeout(timeout);
        this.loading = false;
        if (this.isConnected) {
          this.grid.setAttribute('aria-busy', 'false');
          this.refresh();
          this.observeEnd();
        }
      }
      return success;
    }
    async restorePosition() {
      let saved;
      try {
        saved = JSON.parse(sessionStorage.getItem('vainilla-collection-return'));
      } catch (_) { return; }
      if (performance.getEntriesByType('navigation')[0]?.type !== 'back_forward' || !saved || saved.query !== this.queryKey || Date.now() - saved.at > 1800000) return;
      try { sessionStorage.removeItem('vainilla-collection-return'); } catch (_) {}
      this.restoring = true;
      this.paused = !!saved.paused;
      const target = Math.min(Number(saved.page) || this.page, Number(this.dataset.pages));
      while (this.isConnected && this.nextURL && this.page < target) {
        if (!await this.loadMore()) break;
      }
      if (this.isConnected && this.queryKey === this.getQueryKey()) {
        await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
        const anchor = [...this.grid.children].find(card => card.dataset.productId === saved.product);
        const top = anchor ? anchor.getBoundingClientRect().top + window.scrollY - saved.top : saved.y;
        window.scrollTo({ top: Math.max(0, Number(top) || 0), behavior: 'instant' });
        this.refresh();
      }
      this.restoring = false;
    }
  }
  if (!customElements.get('vainilla-collection-scroll')) customElements.define('vainilla-collection-scroll', VainillaCollectionScroll);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vainilla-currency-label"] && !Shopify.designMode) return;
  try {
    class VainillaCurrencyLabel extends HTMLElement {
    connectedCallback() {
      const header = this.closest('header');
      const label = this.dataset.localLabel;
      if (!header || !label) return;
      this.observer?.disconnect();
      const translate = () => {
        header.querySelectorAll('.buckscc-select-options .geoCurrency .bucksItem').forEach((item) => {
          if (item.textContent !== label) item.textContent = label;
        });
      };
      this.observer = new MutationObserver(translate);
      this.observer.observe(header, { childList: true, characterData: true, subtree: true });
      translate();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
    }
  }
  if (!customElements.get('vainilla-currency-label')) customElements.define('vainilla-currency-label', VainillaCurrencyLabel);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vainilla-header-search"] && !Shopify.designMode) return;
  try {
    class VainillaHeaderSearch extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('keyup', (event) => {
        if (event.key !== 'Escape') return;
        this.querySelector('predictive-search')?.close();
        event.stopPropagation();
      });
    }
  }
  if (!customElements.get('vainilla-header-search')) customElements.define('vainilla-header-search', VainillaHeaderSearch);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["vainilla-latest-products"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('vs-latest-products')) {
    customElements.define('vs-latest-products', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready || this.loading) return;
        this.list = this.querySelector('.vs-latest__list');
        this.status = this.querySelector('.vs-latest__status');
        this.retry = this.querySelector('.vs-latest__retry');
        this.fallback = this.querySelector('.vs-latest__fallback');
        this.more = this.querySelector('.vs-latest__more');
        this.pause = this.querySelector('.vs-latest__pause');
        this.retry.onclick = () => this.loadProducts();
        if (this.more) this.more.onclick = () => this.revealMore();
        if (this.pause) this.pause.onclick = () => {
          const paused = this.toggleAttribute('data-paused');
          this.pause.setAttribute('aria-pressed', String(paused));
          this.pause.textContent = paused ? this.pause.dataset.play : this.pause.dataset.pause;
        };
        this.loadProducts();
      }
      disconnectedCallback() { this.controller?.abort(); }
      async loadProducts() {
        if (this.loading) return;
        this.loading = true;
        this.retry.hidden = true;
        this.fallback.hidden = true;
        this.status.textContent = this.dataset.loadingLabel;
        this.list.setAttribute('aria-busy', 'true');
        this.controller = new AbortController();
        const timeout = setTimeout(() => this.controller.abort(), 15000);
        try {
          const response = await fetch(this.dataset.source, { credentials:'same-origin', signal:this.controller.signal });
          if (!response.ok) throw new Error('feed_unavailable');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const feed = doc.querySelector('[data-vs-latest-feed]');
          if (!feed || feed.dataset.sort !== 'created-descending') throw new Error('feed_invalid');
          const cards = [...feed.querySelectorAll('.vs-latest-card')];
          const total = Number(feed.dataset.total);
          if (!Number.isInteger(total) || total < 1 || total > 60 || cards.length !== total || new Set(cards.map(c => c.dataset.productId)).size !== total) throw new Error('feed_count');
          if (cards.some((c, i) => !Number.isFinite(Number(c.dataset.created)) || i > 0 && Number(cards[i-1].dataset.created) < Number(c.dataset.created))) throw new Error('feed_order');
          if (!this.isConnected) return;
          this.cards = cards.slice(0, this.dataset.mode === 'carousel' ? 12 : 60).map(c => document.importNode(c, true));
          this.list.replaceChildren(...this.cards);
          if (this.dataset.mode === 'carousel') {
            this.style.setProperty('--vs-count', this.cards.length);
            this.cards.forEach(card => {
              const clone = card.cloneNode(true);
              clone.dataset.clone = '';
              clone.setAttribute('aria-hidden', 'true');
              clone.querySelectorAll('a').forEach(a => a.tabIndex = -1);
              this.list.append(clone);
            });
            this.status.textContent = this.label(this.cards.length, total);
            this.pause.hidden = false;
          } else {
            this.shown = 0;
            this.revealMore(false);
          }
          this.dataset.ready = 'true';
        } catch (error) {
          if (!this.isConnected) return;
          this.list.replaceChildren();
          this.status.textContent = this.dataset.errorLabel;
          this.retry.hidden = false;
          this.fallback.hidden = false;
        } finally {
          clearTimeout(timeout);
          this.loading = false;
          this.list.setAttribute('aria-busy', 'false');
        }
      }
      label(shown, total) { return this.dataset.countLabel.replace('__shown__', shown).replace('__total__', total); }
      revealMore(focus = true) {
        const previous = this.shown;
        this.shown = Math.min(this.shown + 20, this.cards.length);
        this.cards.forEach((card, i) => card.hidden = i >= this.shown);
        this.status.textContent = this.label(this.shown, this.cards.length);
        this.more.hidden = this.shown === this.cards.length;
        if (focus) this.cards[previous]?.querySelector('a')?.focus({preventScroll:true});
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
